import { NgModule } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'

export const ICONS_LIST = [
  ['forklift-mini', 'forklift-mini.svg'],
  ['network-0', 'network-0.svg'],
  ['network-1', 'network-1.svg'],
  ['network-2', 'network-2.svg'],
  ['network-3', 'network-3.svg'],
  ['network-4', 'network-4.svg'],
]
@NgModule()
export class IconsModule {
  private _icons: string[][] = ICONS_LIST

  constructor(
    private _matIconRegistry: MatIconRegistry,
    private _domSanitizer: DomSanitizer
  ) {
    this._registerIcons()
  }

  private _registerIcons() {
    for (let icon of this._icons) {
      this._matIconRegistry.addSvgIcon(
        icon[0],
        this._domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/svg/${icon[1]}`
        )
      )
    }
  }
}
